export const ApiAuthUrls = {
  loginUser: '/auth/login',
  signUpUser: '/auth/signup',
  setNewPassword: '/auth/set-password',
  completeRegistration: '/auth/complete-registration',
  completePersonalData: '/auth/complete-personal-data',
  logout: '/auth/logout',
  forceLogout: '/auth/force-logout',
  changeLocale: '/auth/change-locale',
  verifyEmail: '/auth/verify-email',
  verifyPhoneNumber: '/auth/verify-phone-number',
  createVerificationCode: '/auth/request-verification-code',
};
